import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export default function Log() {
  const [entries, setEntries] = useState([]);

  useEffect(() => { api.getActivity().then(setEntries).catch((err) => console.error('Failed to load activity:', err)); }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Activity Log</h1>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Time</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Action</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Guest</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">By</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Details</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {entries.map((entry) => {
              const details = safeParseJSON(entry.details);
              return (
                <tr key={entry.id}>
                  <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
                    {entry.created_at ? new Date(entry.created_at).toLocaleString() : '—'}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900">{entry.action}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{entry.guest_name || '—'}</td>
                  <td className="px-6 py-4 text-sm">
                    <span className={`px-2 py-1 rounded-full text-xs ${entry.performed_by === 'auto' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`}>
                      {entry.performed_by}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500 font-mono text-xs">
                    {Object.entries(details).map(([k, v]) => `${k}: ${v}`).join(', ')}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function safeParseJSON(str) {
  try { return JSON.parse(str); } catch { return {}; }
}
